import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const values = [
  { icon: "ri-heart-line", title: "温暖", desc: "每一部作品都藏着对猫咪和生活最温柔的注视。" },
  { icon: "ri-honour-line", title: "真实", desc: "只推荐真实、可信、有温度的养猫日常内容。" },
  { icon: "ri-eye-line", title: "用心", desc: "认真甄选作品，让轻松快乐常伴你的阅读时光。" },
  { icon: "ri-group-line", title: "陪伴", desc: "和千万铲屎官一起追更、交流、分享养猫的每一天。" },
];

const voices = [
  { name: "小鱼干", role: "养猫两年", text: "每天下班就想看喵趣漫画更新的橘猫日常，太真实了，看着就开心！" },
  { name: "阿桔", role: "新手铲屎官", text: "在这里学到了好多养猫知识，《新手铲屎官指南》救了我家的小奶猫！" },
  { name: "布丁妈", role: "三猫家庭", text: "三猫家庭大作战简直是在演我家，笑死我了，每天必追！" },
];

export default function About() {
  useEffect(() => {
    document.title = "关于我们 - 喵趣漫画网 | 养猫日常漫画在线阅读平台";
  }, []);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于喵趣漫画网",
    description: "喵趣漫画是一个专注于养猫日常漫画的在线阅读平台，汇集喵趣漫画日常、养猫日常、生活日常与日常趣事作品。",
    url: "https://zgqpm41.cn/about",
    inLanguage: "zh-CN",
  };

  return (
    <div className="bg-background-50 min-h-screen">
      <Navbar />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      {/* 关于我们 banner */}
      <section className="relative w-full h-[360px] md:h-[420px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20comic%20style%20illustration%20of%20cats%20and%20people%20reading%20together%20surrounded%20by%20flying%20comic%20pages%20and%20hearts%2C%20soft%20cream%20peach%20and%20orange%20tones%2C%20flat%20art%2C%20heartwarming%20community%20atmosphere&width=1600&height=800&seq=about-banner-01&orientation=landscape"
          alt="关于喵趣漫画网"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/35"></div>
        <div className="relative text-center text-background-50 px-4">
          <h1 className="font-heading text-4xl md:text-5xl drop-shadow">关于喵趣漫画网</h1>
          <p className="mt-3 text-sm md:text-base text-background-50/90 max-w-xl mx-auto">
            一个为养猫人而生的日常漫画阅读平台
          </p>
        </div>
      </section>

      {/* 品牌介绍 */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="font-heading text-3xl text-foreground-950">
              为什么做喵趣漫画？
            </h2>
            <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-700">
              <p>
                养猫的人越来越多，但关于养猫日常的快乐与幽默，却常常散落在各自的生活里。喵趣漫画想把这些温暖瞬间集中起来——喵趣漫画日常、喵趣漫画养猫日常、喵趣漫画生活日常与日常趣事，都被用心收录在这里。
              </p>
              <p>
                我们相信，一部好的日常漫画，不只让人会心一笑，更能让人在忙碌的日子里，重新感受到生活的柔软。无论是清晨被猫咪踩醒，还是深夜看它跑酷，这些小小的日常，都值得被认真记录与分享。
              </p>
              <p>
                从一名普通铲屎官到千万养猫同好，喵趣漫画希望成为每一个爱猫之人「随时随地在线看」的轻松港湾。
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {values.map((v) => (
              <div
                key={v.title}
                className="rounded-2xl bg-background-100/70 border border-background-200 p-5"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-500/10 text-accent-600 text-xl mb-3">
                  <i className={v.icon}></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950">{v.title}</h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 数字 */}
      <section className="bg-primary-500 text-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { n: "10+", l: "连载作品" },
            { n: "80万+", l: "累计阅读" },
            { n: "5万+", l: "铲屎官同好" },
            { n: "4.8", l: "平均评分" },
          ].map((d) => (
            <div key={d.l}>
              <p className="font-heading text-3xl md:text-4xl">{d.n}</p>
              <p className="mt-1 text-xs text-background-50/85">{d.l}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 用户口碑 */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <h2 className="font-heading text-3xl text-foreground-950 text-center">
          铲屎官们怎么说
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          来自真实读者的温暖反馈
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {voices.map((v) => (
            <div
              key={v.name}
              className="rounded-2xl bg-background-100/70 border border-background-200 p-6"
            >
              <div className="flex items-center gap-1 text-accent-500 text-sm mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">“{v.text}”</p>
              <div className="mt-4 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-700 font-heading">
                  {v.name[0]}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-950">{v.name}</p>
                  <p className="text-xs text-foreground-600">{v.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 内容原则 */}
      <section className="bg-background-100/60 border-y border-background-200">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <h2 className="font-heading text-3xl text-foreground-950 text-center">我们的内容原则</h2>
          <p className="mt-2 text-sm text-foreground-600 text-center max-w-xl mx-auto">
            让每一部喵趣漫画养猫日常、生活日常与日常趣事作品都真实、温暖、值得阅读
          </p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              { t: "尊重猫咪，尊重生命", d: "所有作品倡导科学养猫、善待动物，传递温暖正向的价值观。" },
              { t: "内容真实有共鸣", d: "拒绝空泛套路，只选能让铲屎官产生真实共鸣的生活日常。" },
              { t: "持续创作与更新", d: "轻松日常持续更新，陪伴每一位养猫人的追更时光。" },
            ].map((p) => (
              <div key={p.t} className="rounded-2xl bg-background-50 border border-background-200 p-6">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/10 text-accent-600 mb-3">
                  <i className="ri-check-double-line"></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950">{p.t}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}